<template>
  <div class="pcr-inner-chart-container mb-3">
    <div :id="plotDivId"></div>
  </div>
</template>

<script>

  import Plotly from 'plotly.js-cartesian-dist'

  export default {
    name: "PCRCheckChartPlotly",
    data: function () {
        return {
          pcrOkColor: "#5cb85c",
          pcrNotOkColor: "#d9534f"
        }
    },
    props: {
      rankings: Array,
      currentOption: String,
      currentOptionIsRecommended: Boolean,
    },
    computed: {
      plotDivId(){
        return this.currentOption + '-plot-div-id'
      },
      chartData() {

        let bars =[];
        this.rankings.map(s => {
          bars.push(
            {
              x: [s.score],
              y: [s.name],
              width: [0.5],
              type: 'bar',
              orientation: 'h',
              marker: {
                color: this.getBarColor(s.key)
              }
            }
          );

          bars.push(
            {
              x: [s.score],
              y: [s.name],
              text: [s.score],
              mode: "markers+text",
              textposition: (s.score > 14)? 'left':'right' // Keep text visible
            }
          )
        });
        return bars.reverse()
      },
      chartLayout() {
        return {
          xaxis: {
            range: [0, 15],
            title:{
              text: "Points"
            }
          },
          yaxis: {
            showticklabels: true
          },
          height: 200,
          margin: {l: 200, r: 20, b: 40, t: 20},
          barmode: "overlay",
          showlegend: false
        }
      },
      chartOptions(){
        return {
          staticPlot: true,
          responsive: true
        }
      },
      // barColor() {
      //   if (this.isCurrentOption && this.isRecommended) {
      //     return 'green'
      //   } else if (this.isCurrentOption) {
      //     return 'red'
      //   } else {
      //     return 'grey'
      //   }
      // }
    },
    methods: {
      createPlot() {
        Plotly.newPlot(this.plotDivId, this.chartData, this.chartLayout, this.chartOptions)
      },
      getBarColor(optionKey){
        let color = '';
        if (optionKey === this.currentOption){
          // The color for the rehab option described in this report section
          color = this.currentOptionIsRecommended ? 'rgb(58,142,67)':'rgb(220,53,69)'
        } else {
          // The color for rehab options described in other report sections
          color = 'rgb(108,117,125)'
        }

        return color
      }
    },
    mounted() {
      this.createPlot()
    }
  }
</script>

<style scoped>

</style>